

import TicketsView from "./components/Tickets";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";





const Trips = () => {
  const btnClass = `linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;

  return (
    <div>
     

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        
        <div>
          <TicketsView />
        </div>                        
      </div>
    </div>
  );
};

export default Trips;
